/**************
 Collection Item V2
 ***************/

document.querySelectorAll('.collectionItem.v2')?.forEach(item => {
    let product = JSON.parse(item.dataset.product);

    // initialize swiper
    let visualSwiper = new Swiper(item.querySelector(`.collectionItemVisualSwiper`), {
        slidesPerView: 1,
        // disable swiper's a11y module: it adds role="group" to the <img> slides, which is an invalid role for images
        a11y: false,
        scrollbar: {
            el: item.querySelector(`.collectionItemVisualSwiperScrollbar`),
        },
        loop: true
    });

    // event listener for color swatch
    item.querySelectorAll(`.collectionItemSwatch > div`).forEach(function (element) {
        element.addEventListener("click", function () {
            let variant = JSON.parse(element.dataset.variant);
            let color = element.dataset.color;
            let url = element.dataset.url;

            // set the active variant visually
            item.querySelector('.collectionItemVariant').textContent = color;
            item.querySelectorAll(`.collectionItemSwatch > div`).forEach(function (swatch) {
                swatch.classList.remove('active');
                if (swatch.dataset.color === color) {
                    swatch.classList.add('active');
                }
            })

            // update the swiper
            if (variant.featured_image) {
                visualSwiper.slideToLoop(variant.featured_image.position - 1);

                item.querySelector('.collectionItemVisualHero').src = variant.featured_image.src;
            }

            // update url
            item.querySelectorAll('a').forEach(function (anchor) {
                anchor.href = url;
            })

        });
    });

    setupWishlist(item.querySelector(`.collectionItemWishlist`), product);
})